import {
  Dialog,
  Button,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

interface Props {
  open: boolean;
  handleCancel: () => void;
  handleStay: () => void;
}

function CancelWarningModal(props: Props) {
  return (
    <Dialog
      open={props.open}
      aria-labelledby="cancel-warning-dialog-title"
      aria-describedby="cancel-warning-dialog-description"
    >
      <DialogTitle id="cancel-warning-dialog-title">
        {"Cancel Builder?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="cancel-warning-dialog-description">
          If you leave the builder page, your progress will be lost. Do you want
          to leave?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleStay} variant="contained">
          No
        </Button>
        <Button onClick={props.handleCancel} variant="text">
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default CancelWarningModal;
